import { API } from '../../../config';
import { errorHandler } from '../auth/errorAction';

export const unmountListService = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_SERVICE'})
}

export const unmountDetailService = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_SERVICE'})
}

export const unmountEditService = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_EDIT_SERVICE'})
}

export const unmountMasterService = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_SERVICE'})
}

export const listService = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_SERVICE' })
  return API.GET('/service/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_SERVICE_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_SERVICE_FAILED' }), 
    ))
  })
}

export const detailService = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_SERVICE' })
  const params = {
    'id': id
  }
  API.GET('/service/getDetailById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_SERVICE_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_SERVICE_FAILED' }), 
      ))
    )
  })
}

export const editService = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_EDIT_SERVICE' })
  const params = {
    'id': id
  }
  API.GET('/service/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_EDIT_SERVICE_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_EDIT_SERVICE_FAILED' }), 
      ))
    )
  })
}

export const masterService = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_SERVICE' })
  return API.GET('/employers_type/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_SERVICE_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: null,
          total: null,
          perpage: null
        }
    }})
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_SERVICE_FAILED' }), 
    ))
  })
}

export const createService = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA_ARRAY('/service/add', value, 'createService').then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const updateService = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA_ARRAY('/service/update', value, 'createService').then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableService = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/service/enable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableService = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/service/disable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const checkTicketService = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/xpert/ticket/checkTicket', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}